import React from 'react';

import IconWithText from 'components/Widgets/IconWithText';

export default function PrepareReportGeneral() {
  return (
    <>
      <h6 className="text-center" style={{ maxWidth: '600px', margin: '0 auto', paddingTop: '80px' }}>
        LeggUP is dedicated to developing exceptional leaders through our proprietary
        approach, which integrates neuroplasticity, positive psychology, and
        intentional change theory. We focus on enhancing your confidence and
        readjustment skills—no rushing, no added pressure, just support for
        your successful leadership development.
      </h6>

      <div className="row" style={{ marginTop: '100px', paddingBottom: '100px' }}>
        <div className="col text-center">
          <IconWithText
            iconClassName="onboarding-balance-icon big-icon bg-secondary mx-auto"
          />

          <h3 className="mt-2 mb-2">67%</h3>
          <h6>achieved better work-life integration</h6>
        </div>

        <div className="col text-center">
          <IconWithText
            iconClassName="onboarding-stress-icon big-icon bg-secondary mx-auto"
          />

          <h3 className="mt-2 mb-2">42%</h3>
          <h6>experienced enhanced decision-making</h6>
        </div>
      </div>
    </>
  );
}
